module.exports = __webpack_public_path__ + "img/agregar_usuario.77223bea.svg";